import styled from 'styled-components';
import handleSpaces, { spacingProps } from '../utils/handleSpaces';

export const convertToPixel = (value) => {
  if (value === undefined) return value;
  return typeof value === 'number' ? `${value}px` : value;
};

const Flex = styled.div.attrs((props) => {
  return {
    direction: props.direction || 'row',
    justify: props.justify || 'left',
    align: props.align || 'flex-start',
    padding: props.padding || '0',
    margin: props.margin || '0',
    width: props.width,
    height: props.height,
    wrap: props.wrap || 'nowrap',
    gap: props.gap || '0',
    ...spacingProps(props),
  };
})`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  justify-content: ${({ justify }) => justify};
  align-items: ${({ align }) => align};
  padding: ${({ padding }) => padding};
  margin: ${({ margin }) => margin};
  width: ${({ width }) => convertToPixel(width)};
  height: ${({ height }) => convertToPixel(height)};
  flex-wrap: ${({ wrap }) => wrap};
  gap: ${({ gap }) => convertToPixel(gap)};
  ${handleSpaces}
`;

export default Flex;
